import {
  makeLazyQueryHook,
  makeMutationHook,
  makeQueryHook,
} from "utils/apolloUtils";

import {
  TICKET_TEMPLATE_CREATE_MUTATION,
  TICKET_TEMPLATE_DELETE_MUTATION,
  TICKET_TEMPLATE_UPDATE_MUTATION,
} from "./mutations";
import { TICKET_TEMPLATES_QUERY, TICKET_TEMPLATE_QUERY } from "./queries";
import {
  TicketTemplateCreate,
  TicketTemplateCreateVariables,
  TicketTemplateDelete,
  TicketTemplateDeleteVariables,
  TicketTemplateUpdate,
  TicketTemplateUpdateVariables,
} from "./__generated__/mutations";
import {
  TicketTemplates,
  TicketTemplatesVariables,
  TicketTemplateQuery,
  TicketTemplateQueryVariables,
} from "./__generated__/queries";

export const useTicketTemplateCreateMutation = makeMutationHook<
  TicketTemplateCreate,
  TicketTemplateCreateVariables
>(TICKET_TEMPLATE_CREATE_MUTATION);

export const useTicketTemplateUpdateMutation = makeMutationHook<
  TicketTemplateUpdate,
  TicketTemplateUpdateVariables
>(TICKET_TEMPLATE_UPDATE_MUTATION);

export const useTicketTemplateDeleteMutation = makeMutationHook<
  TicketTemplateDelete,
  TicketTemplateDeleteVariables
>(TICKET_TEMPLATE_DELETE_MUTATION);

export const useTicketTemplatesQuery = makeQueryHook<
  TicketTemplates,
  TicketTemplatesVariables
>(TICKET_TEMPLATES_QUERY);

export const useTicketTemplateQuery = makeQueryHook<
  TicketTemplateQuery,
  TicketTemplateQueryVariables
>(TICKET_TEMPLATE_QUERY);

export const useTicketTemplateLazyQuery = makeLazyQueryHook<
  TicketTemplateQuery,
  TicketTemplateQueryVariables
>(TICKET_TEMPLATE_QUERY);
